import creditEngineRepository, { CreditEngineRepository } from "./CreditEngineRepository";
import { ContentTypes } from "../../utils/ContentTypes";

const resource = "paymentgateway";

export default {
  getDownpaymentConfiguration(loanId) {
    const clientPaymentConfigurationRequestDto = {
      loanId: loanId,
      paymentPurpose: "DOWNPAYMENT"
    };

    creditEngineRepository.setContentType(ContentTypes.APPLICATION_JSON);
    return CreditEngineRepository.post(
      `${resource}/configuration`,
      clientPaymentConfigurationRequestDto
    );
  },

  verifySignature(loanId, orderId, paymentId, signature) {
    const paymentCaptureRequest = {
      loanId: loanId,
      orderId: orderId,
      paymentId: paymentId,
      signature: signature
    };

    creditEngineRepository.setContentType(ContentTypes.APPLICATION_JSON);
    return CreditEngineRepository.post(
      `${resource}/verifySignature`,
      paymentCaptureRequest
    );
  }
}
